import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_show_2_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_show_2_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_show_2_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_show_2_plans~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__b'),
			},
		},
	},
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_show_2_plans~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_show_2_plans~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__c'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_show_2_plans~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_show_2_plans~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_show_2_plans__c'),
			},
		},
	},
]

export default config
